import { ListItem } from '@tableau/widgets';
import { SortOptions } from './SortOptions';

export interface SortSelection {
  name: string;
  primarySort: ListItem;
  primarySortDirection?: Direction;
  secondarySort?: ListItem;
  secondarySortDirection?: Direction;
}

export enum Direction {
  asc = 'asc',
  desc = 'desc',
}

export namespace SortBy {
  export function getRelevancySortSelection(): SortSelection {
    return {
      name: 'relevancy',
      primarySort: SortOptions.getRelevancyItem(),
      primarySortDirection: Direction.desc,
    };
  }

  export function getPopularitySortSelection(): SortSelection {
    return {
      name: 'popularity',
      primarySort: SortOptions.getHitsMediumSpanTotalItem(),
      primarySortDirection: Direction.desc,
      secondarySort: SortOptions.getHitsTotalItem(),
      secondarySortDirection: Direction.desc,
    };
  }

  export function getWorkbookPopularity(): SortSelection {
    return {
      name: 'popularity',
      primarySort: SortOptions.getDownstreamWorkbookCountItem(),
      primarySortDirection: Direction.desc,
    };
  }
}
